import { render } from "./slide24.vue?vue&type=template&id=7be93bf9"
import script from "./slide24.vue?vue&type=script&lang=js"
export * from "./slide24.vue?vue&type=script&lang=js"

import "./slide24.vue?vue&type=style&index=0&id=7be93bf9&lang=scss"

import exportComponent from "/Users/dima/Projects/OrangeStatic/rise-homestories/public/themes/rise-theme/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__